/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/1/2022.
 */

import {fetchUsers as usersFetchUsers} from '../../api/Users'

export const REQUEST_USERS = 'REQUEST_USERS'
export const RECEIVE_USERS = 'RECEIVE_USERS'

export const fetchUsers = (search, sort, sortOrder) => dispatch => {
    dispatch(requestUsers());
    return usersFetchUsers(search, sort, sortOrder, null, null, null, null, ['ACTIVE', 'DISABLED']).then(
        function (response) {
            dispatch(receiveUsers(response));
        }
    );
}

const requestUsers = () => {
    return {
        type: REQUEST_USERS,
    }
}

const receiveUsers = (users) => {
    return {
        type: RECEIVE_USERS,
        users: users,
    }
}